"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAlphanumericLocales = exports.isAlphanumeric = void 0;
const assertString_1 = require("./util/assertString");
const alpha_1 = require("./alpha");
function isAlphanumeric(_str, locale = 'en-US', options = {}) {
    (0, assertString_1.assertString)(_str);
    let str = _str;
    const { ignore } = options;
    if (ignore) {
        if (ignore instanceof RegExp) {
            str = str.replace(ignore, '');
        }
        else if (typeof ignore === 'string') {
            str = str.replace(new RegExp(`[${ignore.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, '\\$&')}]`, 'g'), ''); // escape regex for ignore
        }
        else {
            throw new Error('ignore should be instance of a String or RegExp');
        }
    }
    if (locale in alpha_1.alphanumeric) {
        return alpha_1.alphanumeric[locale].test(str);
    }
    throw new Error(`Invalid locale '${locale}'`);
}
exports.isAlphanumeric = isAlphanumeric;
exports.isAlphanumericLocales = Object.keys(alpha_1.alphanumeric);
